'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const designSystem = require('@zapier/design-system');
const reactAriaComponents = require('react-aria-components');

const styles = react.css(Object.assign(Object.assign({}, designSystem.Typography.SmallPrint1), { color: `var(--zds-text-weaker, ${designSystem.Colors.GrayWarm9})`, '&[data-compact="true"]': Object.assign({}, designSystem.Typography.MinimalPrint1) }));
const Description = (_a) => {
  var { children, isCompact } = _a, props = tslib_es6.__rest(_a, ["children", "isCompact"]);
  return react.jsx(reactAriaComponents.Text, Object.assign({ slot: "description" }, props, { css: styles, "data-compact": isCompact, "data-zds": true }), children);
};

exports.Description = Description;
//# sourceMappingURL=Description.cjs.js.map
